module.exports = __webpack_public_path__ + "img/TCS.850ca5b0.png";